/**
 * @generated SignedSource<<8c35bf123286206ccc3a847aa08f60d7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type planQuery$variables = {
  userId?: string | null | undefined;
};
export type planQuery$data = {
  readonly insurance_agent_connection: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly insurance_org: {
          readonly customplanprice: number | null | undefined;
          readonly expireddate: any | null | undefined;
          readonly id: string;
          readonly insurance_agents: ReadonlyArray<{
            readonly id: string;
            readonly name: string;
            readonly orgid: string | null | undefined;
            readonly personalplanexpireddate: any | null | undefined;
            readonly phoneNumbers: ReadonlyArray<string>;
            readonly plantype: number;
          }>;
          readonly managerid: string;
          readonly numberofperson: number | null | undefined;
          readonly orgId: string;
          readonly palnType: number;
          readonly valid: boolean;
        } | null | undefined;
        readonly name: string;
        readonly orgid: string | null | undefined;
        readonly personalplanexpireddate: any | null | undefined;
        readonly phoneNumbers: ReadonlyArray<string>;
        readonly plantype: number;
      };
    }>;
  };
};
export type planQuery = {
  response: planQuery$data;
  variables: planQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "orgid",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "personalplanexpireddate",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "plantype",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "phoneNumbers",
  "storageKey": null
},
v7 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "_eq",
                "variableName": "userId"
              }
            ],
            "kind": "ObjectValue",
            "name": "id"
          }
        ],
        "kind": "ObjectValue",
        "name": "where"
      }
    ],
    "concreteType": "insurance_agentConnection",
    "kind": "LinkedField",
    "name": "insurance_agent_connection",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "insurance_agentEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "insurance_agent",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "insurance_org",
                "kind": "LinkedField",
                "name": "insurance_org",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "customplanprice",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "expireddate",
                    "storageKey": null
                  },
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "managerid",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "orgId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "numberofperson",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "palnType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "valid",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "insurance_agent",
                    "kind": "LinkedField",
                    "name": "insurance_agents",
                    "plural": true,
                    "selections": [
                      (v1/*: any*/),
                      (v2/*: any*/),
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "planQuery",
    "selections": (v7/*: any*/),
    "type": "query_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "planQuery",
    "selections": (v7/*: any*/)
  },
  "params": {
    "cacheID": "89f0aa9429e91133f25629f5b8362a9e",
    "id": null,
    "metadata": {},
    "name": "planQuery",
    "operationKind": "query",
    "text": "query planQuery(\n  $userId: String\n) {\n  insurance_agent_connection(where: {id: {_eq: $userId}}) {\n    edges {\n      node {\n        id\n        name\n        orgid\n        personalplanexpireddate\n        plantype\n        phoneNumbers\n        insurance_org {\n          customplanprice\n          expireddate\n          id\n          managerid\n          orgId\n          numberofperson\n          palnType\n          valid\n          insurance_agents {\n            id\n            name\n            orgid\n            personalplanexpireddate\n            plantype\n            phoneNumbers\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "1c32c309c340cc145edecf3210a4c0f1";

export default node;
